module.exports = __webpack_public_path__ + "static/img/3944_phase_function_Paper_Points.be99e08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3944_phase_function_Paper_Points.png
// module id = p+P3
// module chunks = 0